import { PresetKey } from '../types'

export const DEFAULT_PLACEHOLDER = 'dd/mm/aa'

export const PRESET_LABELS: Record<PresetKey | 'custom' | '', string> = {
  today: 'Hoje',
  lastWeek: 'Semana passada',
  lastMonth: 'Mês passado',
  custom: 'Período customizado',
  '': 'Escolha um periodo',
}
